/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coaching_ConfirmInputs */

const en_coaching_confirm = /** @type {(inputs: Coaching_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I have booked it`)
};

const id_coaching_confirm = /** @type {(inputs: Coaching_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sudah saya pesan`)
};

/**
* | output |
* | --- |
* | "I have booked it" |
*
* @param {Coaching_ConfirmInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const coaching_confirm = /** @type {((inputs?: Coaching_ConfirmInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coaching_ConfirmInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_coaching_confirm(inputs)
	return en_coaching_confirm(inputs)
});